import { Directive, Host, HostListener, Input, Optional } from '@angular/core';
import { NgModel } from '@angular/forms';

/**
 * Makes sure that number has decimal format
 *
 *   <input [(ngModel)]="value"
 *          [decimalFormat]
 *          type="number"
 *          inputmode="numeric"
 *          />
 *
 * can be used with text field too
 *
 */
@Directive({
    selector: '[decimalFormat]',
    standalone: true
})
export class DecimalFormatDirective {
    /**
     * Just to make compiler happy
     */
    @Input()
    decimalFormat;

    /**
     * Dependencies
     */
    constructor(@Optional() @Host() private ngModel: NgModel) {}

    /**
     * Custom value input
     */
    @HostListener('input', ['$event'])
    onInput(event: InputEvent) {
        const el = event.target as HTMLInputElement;
        if (el.value) {
            const strVal = el.value;
            const value = parseFloat(strVal.replace(/[^\d,.]/g, ''));

            const valueFormatted = typeof value === 'number' && value > -1 ? Math.round(value * 100) / 100 : '';
            const strValueFormatted = typeof valueFormatted === 'number' && valueFormatted > -1 ? valueFormatted + '' : '';

            if (strValueFormatted !== strVal && !(`${strValueFormatted}.` === strVal && !strValueFormatted.includes('.'))) {
                el.value = strValueFormatted;
                const isNumber = el.type === 'number';
                this.ngModel.control.setValue(isNumber ? valueFormatted : strValueFormatted);
            }
        }
    }
}
